import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import FGTargetDaysofSupply from "./FGTargetDaysofSupply";
import { setActiveDataElement } from "../../../redux/userSlice";

const FGTargetDays = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("FG Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection title="FG Inventory Target Days of Supply" />
            <div class="container">
              <FGTargetDaysofSupply />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default FGTargetDays;
 
